"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("./helpers");

var _table = _interopRequireDefault(require("../table"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var buildHoursData = function buildHoursData(rates, index) {
  var to = rates[index].to;
  var from = index > 0 ? rates[index - 1].to : 0;
  return "".concat((0, _helpers.formatHours)(from)).concat(to ? " - ".concat((0, _helpers.formatHours)(to), " hrs") : ' hrs +');
};

var buildRateString = function buildRateString(rate) {
  return rate === 0 ? 'Free' : (0, _helpers.formatRate)(rate);
};

var columns = [{
  key: 'hours',
  heading: 'Hours'
}, {
  key: 'rate',
  heading: 'Rate'
}];

var ParkingRatesTable = function ParkingRatesTable(_ref) {
  var rates = _ref.rates;
  var rows = rates.map(function (r, i) {
    return {
      hours: buildHoursData(rates, i),
      rate: buildRateString(r.rate)
    };
  });
  return /*#__PURE__*/_react.default.createElement(_table.default, {
    className: _indexModule.default.ratesTable,
    columns: columns,
    rows: rows
  });
};

ParkingRatesTable.propTypes = {
  rates: _propTypes.default.arrayOf(_propTypes.default.shape({
    to: _propTypes.default.number,
    rate: _propTypes.default.number.isRequired
  })).isRequired
};
var _default = ParkingRatesTable;
exports.default = _default;